import React, { Component } from "react";
import { Table, Spin, Button, message } from "antd"; 
import { API } from "../../../API/API";
import { baseConfig } from "../../../Config/Config";
import UserContext from "../../UserContext/UserContext";

class StakeHolderFirstRoundEvaluationTable extends Component {
  static contextType = UserContext;
  state = {
    invitationid: this.props.invitationid,
    tblvendor: [],
    tblcriteria: [],
    tblevaluation: [],
    loading: true,
    selectedVendorKeys: [],
    selectedVendors: [],
  };

  async componentDidMount() {
    try {
      // Fetch Invitation's vendors
      const vendorsResponse = await API.get("/getInvitationsVendorListAll?invitationid=" + this.state.invitationid);
      if (vendorsResponse.status === 200) {
        this.setState({
          tblvendor: vendorsResponse.data.retData,
        });
      }

      // Fetch criteria of invitation  
      const criteriaResponse = await API.get("/getCriteriaList?invitationid=" + this.state.invitationid);
      if (criteriaResponse.status === 200) {
        this.setState({
          tblcriteria: criteriaResponse.data.retData,
        });
      }

      // Fetch evaluations by members
      const evaluationsResponse = await API.get("/getInvitationsVendorFirstEvaluationList?invitationid=" + this.state.invitationid);
      if (evaluationsResponse.status === 200) {
        this.setState({
          tblevaluation: evaluationsResponse.data.retData,
          loading: false, // Data loaded, set loading to false
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ loading: false });
    }
  }
  
  handleSaveClick = async () => {
    const { selectedVendors, tblvendor } = this.state;
  
    const vendorsWithSelection = tblvendor.map((vendor) => {
        const isSelected = selectedVendors.some((selected) => Number(selected.key) === Number(vendor.vendorid));
        
        return {
          ...vendor,
          won_first_round: isSelected ? 1 : 0, // 1 for selected, 0 for not selected
          createdby_first_round: this.context.userid,
          stage:1,
        };
    });
    try {
        // Send data to the API
        let bodySubmit = [...vendorsWithSelection]; 
        const response = await API.post("/saveInvitationVendorRoundSelectionResult", bodySubmit);

        if (response.status === 200) {
          message.success("Шалгаруулалт амжилттай!");
          this.props.showForm(false, 0);
        } else {
          message.error("Алдаа гарлаа. Дахин оролдоно уу.");
        }
      } catch (error) {
        console.error("Error updating vendor selection:", error);
        message.error("Алдаа гарлаа. Дахин оролдоно уу.");
      }
  };

  render() {
    const { tblvendor, tblevaluation, loading } = this.state;

    const dataSource = tblvendor.map((vendor) => {

      const vendorEvals = tblevaluation.filter((e) => e.vendorid === vendor.vendorid);
      const children = vendorEvals.map((empEval) => {
        return {
          key: `${vendor.vendorid}-${empEval.empid}`,
          vendorname: "",  
          createdby: empEval.createdby,
          empid: empEval.empid,
          comment:empEval.first_round_comment,
          selected: empEval.first_round_status === 5 ? 1 : 0, // "Шалгаруулсан" count for this row
          notSelected: empEval.first_round_status === 4 ? 1 : 0, // "Шалгаруулаагүй" count for this row
        };
      });

      return {
        key: vendor.vendorid,
        vendorname: vendor.vendorname,
        selected: vendorEvals.filter((e) => e.first_round_status === 5).length,  // "Шалгаруулсан" count for vendor
        notSelected: vendorEvals.filter((e) => e.first_round_status === 4).length,  // "Шалгаруулаагүй" count for vendor
        children,  // Add children rows for each employee evaluation
      };
    });

    // Row selection: get checked rows
    const rowSelection = {
      selectedRowKeys: this.state.selectedVendorKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          selectedVendorKeys: selectedRowKeys,
          selectedVendors: selectedRows,
        });
      },
    };

    const columns = [
      {
        title: "Оролцогч компани",
        dataIndex: "vendorname",
        key: "vendorname",
        render: (text) => text ?? '',
      },
      {
        title: "Шалгаруулсан",
        dataIndex: "selected",
        key: "selected",
        render: (text) => text ?? 0,
      },
      {
        title: "Шалгаруулаагүй",
        dataIndex: "notSelected",
        key: "notSelected",
        render: (text) => text ?? 0,
      },
    ];

    if (loading) {
      return <Spin tip="Loading Evaluation Table..." />;
    }

    return (
      <div>
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          bordered
          rowKey="key"
          rowSelection={rowSelection}
          expandable={{
            expandedRowRender: (record) => (
              <Table
                rowKey="empid"
                columns={[
                  { title: "Үнэлсэн ажилтан", dataIndex: "createdby", key: "createdby" },
                  { title: "Тайлбар", dataIndex: "comment", key: "comment" },
                  { title: "Шалгаруулсан", dataIndex: "selected", key: "selected" },
                  { title: "Шалгаруулаагүй", dataIndex: "notSelected", key: "notSelected" },
                ]}
                dataSource={record.children}
                pagination={false}
                bordered
              />
            ),
            rowExpandable: (record) => record.children && record.children.length > 0,
          }}
        />
        <div>
          <Button
            type="primary"
            style={{ marginTop: 16 }}
            onClick={this.handleSaveClick}
          >
            II шатанд шалгаруулах
          </Button>
        </div>
      </div>
    );
  }
}

export default StakeHolderFirstRoundEvaluationTable;
